<template>
  <v-container fluid class="will-summary">
    <div v-if="!loading">
      <v-row v-if="notAuthorizedError">
        <v-col cols="12" class="text-center">
          <h3>You are not authorized to view this page</h3>
        </v-col>
      </v-row>

      <v-row v-else no-gutters>
        <v-col cols="12" sm="1">
          <router-link :to="redirectBackLocation" class="back-arrow"
            ><v-icon large color="mid-grey">{{
              icons.mdiArrowLeft
            }}</v-icon></router-link
          >
        </v-col>
        <v-col cols="12" sm="11">
          <v-row no-gutters>
            <v-col cols="12" sm="10">
              <CompanyDetails :company="company" />
            </v-col>
            <v-col cols="12" sm="2">
              <v-btn
                depressed
                large
                rounded
                color="primary"
                @click.stop="showDialog = true"
              >
                Edit company
              </v-btn>
            </v-col>
          </v-row>

          <h2 class="mt-6">Company users</h2>
          <CompanyUsersList :company="company" :includes-testators="false" />
        </v-col>
      </v-row>
    </div>

    <div v-else class="text-center">
      <v-progress-circular indeterminate color="primary" />
    </div>

    <CompanyDialog v-model="showDialog" :company-to-update="company" />
    <SuccessSnackbar v-model="showSuccess" :message="successMessage" />
  </v-container>
</template>

<script>
  import { COMPANY_QUERY } from '../../../constants/graphql/companies';
  import CompanyDialog from './CompanyDialog.vue';
  import CompanyDetails from './CompanyDetails.vue';
  import CompanyUsersList from './CompanyUsersList.vue';
  import SuccessSnackbar from '../../common/SuccessSnackbar.vue';

  export default {
    name: 'CompanyPage',
    components: {
      CompanyDialog,
      CompanyDetails,
      CompanyUsersList,
      SuccessSnackbar,
    },
    props: {
      successMessage: {
        required: false,
        default: null,
        type: String,
      },
    },
    data() {
      return {
        company: {},
        loading: true,
        notAuthorizedError: false,
        showDialog: false,
        showSuccess: false,
      };
    },
    computed: {
      redirectBackLocation() {
        if (this.$store.getters.isCompanyAdmin) {
          return '/advisors';
        } else {
          return '/advisors/companies';
        }
      },
    },
    created() {
      if (this.successMessage) this.showSuccess = true;
    },
    apollo: {
      company: {
        query: COMPANY_QUERY,
        variables() {
          return {
            id: this.$route.params.id,
          };
        },
        fetchPolicy: 'cache-and-network',
        result(response) {
          if (response.data) {
            this.loading = false;
            if (response.data.company == null) this.notAuthorizedError = true;
          }
        },
      },
    },
  };
</script>
